import React from 'react';

interface LinkifiedTextProps {
  text: string;
}

const URL_SPLIT_PATTERN = /((?:https?:\/\/|www\.)[^\s]+)/gi;
const URL_TOKEN_PATTERN = /^(?:https?:\/\/|www\.)[^\s]+$/i;
const TRAILING_PUNCTUATION_PATTERN = /[),.!?;:]+$/;

const splitTrailingPunctuation = (value: string) => {
  const trailingMatch = value.match(TRAILING_PUNCTUATION_PATTERN);

  if (!trailingMatch) {
    return { url: value, trailing: '' };
  }

  const trailing = trailingMatch[0];
  const url = value.slice(0, -trailing.length);

  if (!url) {
    return { url: value, trailing: '' };
  }

  return { url, trailing };
};

const toHref = (url: string) => {
  if (url.startsWith('www.')) {
    return `https://${url}`;
  }

  return url;
};

export const LinkifiedText: React.FC<LinkifiedTextProps> = ({ text }) => {
  if (!text) {
    return null;
  }

  const parts = text.split(URL_SPLIT_PATTERN);

  return (
    <>
      {parts.map((part, index) => {
        if (!URL_TOKEN_PATTERN.test(part)) {
          return <React.Fragment key={`text-${index}`}>{part}</React.Fragment>;
        }

        const { url, trailing } = splitTrailingPunctuation(part);
        const href = toHref(url);

        return (
          <React.Fragment key={`url-${index}`}>
            <a href={href} target="_blank" rel="noopener noreferrer">
              {url}
            </a>
            {trailing}
          </React.Fragment>
        );
      })}
    </>
  );
};
